import { render, staticRenderFns } from "./NewAppsDownloadSec.vue?vue&type=template&id=28e01993&scoped=true&"
import script from "./NewAppsDownloadSec.vue?vue&type=script&lang=js&"
export * from "./NewAppsDownloadSec.vue?vue&type=script&lang=js&"
import style0 from "./NewAppsDownloadSec.vue?vue&type=style&index=0&id=28e01993&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e01993",
  null
  
)

export default component.exports